/* eslint-disable @typescript-eslint/ban-ts-comment */

// VENDOR: i18n
import { createI18n } from 'vue-i18n'

// PERSONAL LIBS
import messages from '../'
import { defaultLanguage } from './constants'
import { getMiniISO } from './helpers'
import { IRateLimit } from '@shared/interface/rate-limit.interface'
import { timestampToLitteral } from '@shared/lib/date.lib'

// Create I18n instance
export const i18n = createI18n({
  locale: defaultLanguage,
  legacy: false,
  silentTranslationWarn: process.env.NODE_ENV === 'production',
  fallbackLocale: 'en-US',
  // warnHtmlInMessage: process.env.NODE_ENV === 'production' ? 'off' : 'on',
  warnHtmlInMessage: 'off',
  messages
})

// @ts-ignore
export const $t = i18n.global.t.bind(i18n)

export const $rt = (key: string, rateLimiter?: IRateLimit): string => {
  const isRateLimitError = key.includes('ERR_RATE_LIMIT')
  const keyedString = $t(key)
  const rateLimiterTrials = rateLimiter != null && !isRateLimitError
    ? `${$t('generic.rateLimiter.trials', { rateLimitRemaining: rateLimiter?.remaining ?? 0})}`
    : undefined
  // const rateLimiterTrials = `${$t('generic.rateLimiter.trials', { rateLimitRemaining: rateLimiter?.remaining ?? 0})}`
  const rateLimiterRenewedAt =  rateLimiter != null && ((rateLimiter?.remaining ?? 0) === 0 || isRateLimitError)
    ? `${$t('generic.rateLimiter.renewedAt', { rateLimitReset: timestampToLitteral(rateLimiter?.reset ?? 0)})}`
    : undefined

  return `${keyedString}${rateLimiter != null ? '<br>' : ''}${rateLimiterTrials ?? ''}${rateLimiterTrials != null && rateLimiterRenewedAt != null ? '<br>' : ''}${rateLimiterRenewedAt ?? ''}`
}

export const getLanguage = async (): Promise<string> => {
  let language = defaultLanguage

  // Defines default language (browser language)
  language = getMiniISO(navigator.language.toLowerCase())

  return language
}
